// @flow

import React from 'react'
import { markdown } from 'markdown'
import Appear from './Appear'

type Props = {
  title: string,
  text: string
}

const Organization1 = ({ title, text }: Props) => {
  return (
    <Appear>
      <div className="h-4 border-b-4 border-dashed border-light-gray bg-pink" />
      <div className="px-5 pt-6 pb-4 md:pl-8 md:pr-24 ">
        <h4 className="mb-4 text-base font-bold leading-tight md:text-lg md:mb-4 text-purple">{title}</h4>
        {text && 
          <div className="flex-1 mb-3 text-base font-light md:text-lg markdownNoMargin innerStrongBlack" dangerouslySetInnerHTML={{ __html: markdown.toHTML(text) }}/>
        }
      </div>
    </Appear>
  )
}

export default Organization1
